<template>
  <div class="mb-page-wrap2">
    <div class="tit-group">
      <h2 class="tit">{{t('message.myBoard')}}</h2>
    </div>
    <div class="tit-group02 ty01 mo-home-add">
      <BtnIcon class="btn-ico-home" @click="utils.movePage('/myBoard')"></BtnIcon>
      <h2 class="tit">{{t('message.correctiveAction')}}</h2>
    </div>
    <div class="content-box bg-none">

      <div class="content-inner-box-wrap">
        <div class="content-inner-box">
          <div class="form-wrap">
            <div class="form-group col-ty">
              <div class="tit-group">
                <div class="tit02">{{t('message.detailedInfo')}}</div>
              </div>
              <!--form-row-->
              <div class="form-row" v-if="item.type=='1'">
                <div class="txt-tit">{{t('message.behavior')}}</div>
                <div class="row">{{ item.behaviorTitle }}</div>
              </div>
              <!--form-row-->
              <div class="form-row">
                <div class="txt-tit">{{t('message.registrant')}}</div>
                <div class="row">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
              </div>
              <!--form-row-->
              <div class="form-row" v-if="item.type=='1'">
                <div class="txt-tit">{{t('message.location')}}</div>
                <div class="row">{{ item.placeName }}</div>
              </div>
              <!--form-row-->
              <div class="form-row">
                <div class="txt-tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}</div>
                <div class="row">{{ item.situation }}</div>
              </div>
              <!--form-row-->
              <div class="form-row" v-if="item.type=='1'">
                <div class="txt-tit">{{t('message.cause')}}</div>
                <div class="row">{{ item.cause }}</div>
              </div>
              <!--form-row-->
              <div class="form-row" v-if="item.type=='1'">
                <div class="txt-tit">{{t('message.correctiveActionContent')}}</div>
                <div class="row">{{ item.action }}</div>
              </div>
              <!--form-row-->
              <div class="form-row">
                <div class="txt-tit">{{item.type=='1'?t('message.correctiveActionTarget'):t('message.praiseTarget')}}</div>
                <div class="row">{{ item.targetText }}</div>
              </div>
              <!--form-row-->
              <div class="form-row">
                <div class="txt-tit">{{t('message.registrationDate')}}</div>
                <div class="row">{{ dayjs(item.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD HH.mm.ss') }}</div>
              </div>
              <!--form-row-->
              <div class="form-row" v-if="item.actionYn=='Y'">
                <div class="txt-tit">{{t('message.actionDeadline')}}</div>
                <div class="row">{{ dayjs(item.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(item.goalDate).format('YYYY-MM-DD') }}</div>
              </div>

              <div class="img-slider02">
                <v-carousel
                  v-model="timelineImageModel"
                >
                  <div class="img-wrap ty01">
                    <v-carousel-item
                      v-for="(image,i) in item.timelineImages"
                      :key="i"
                      :src="utils.getBaseUrl('timeline', image.filePath)"
                      cover
                      @click="onClickPreview(image, 'timeline')"
                    ></v-carousel-item>
                  </div>
                </v-carousel>
              </div>
            </div>
            <div class="bottom-btn-group ty03">
              <div class="radio-group2 ty01" v-if="item.type=='1'">
                <v-radio-group v-model="item.status" @change="onChangeStatus" :disabled="!isTargetButtonAble()" v-if="item.actionYn === 'Y'">
                  <v-radio :label="t('message.inProgress')" value="2" :disabled="item.status=='4'"></v-radio>
                  <v-radio :label="t('message.onHold')" value="3" :disabled="item.status=='4'"></v-radio>
                  <v-radio :label="t('message.complete')" value="4" :disabled="item.status=='4'"></v-radio>
                </v-radio-group>
              </div>
              <div class="wr">
                <c-btn02 :btnText="t('message.delete')" class="ty02" @click="dialogActionDeleteModel=true" v-if="isMyBoard()"/>
                <c-btn02 :btnText="t('message.changeTarget2')" class="ty02" @click="() => { if (isTargetButtonAble()) onClickTarget() }" :disabled="!isTargetButtonAble()"  v-if="item.actionYn === 'Y'"/>
              </div>
            </div>
          </div>
        </div>
        <div class="content-inner-box ty02">
          <div class="tit-group mo-ty01">
            <h4 class="tit">{{t('message.history')}}</h4>
          </div>
          <div class="form-wrap">
            <div class="form-wrap-inner">
              <div class="tit-group">
                <h4 class="tit">{{t('message.history')}}</h4>
              </div>
              <div class="history-group scrollbar">
                 <div class="box"
                      v-for="(comment,i) in item.timelineLogs"
                      :key="i" >
                  <div class="txt-group">
                    <div class="txt">{{dayjs(comment.regDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(comment.regDate).format('YYYY-MM-DD HH:mm:ss')}}</div>
                    <div class="txt2">
                      <div class="tag-icon-group">
                        <!-- changeType 변경상태 1:생성 2:코멘트 3:상태변경 4:전달 5:코멘트삭제 -->
                        <!-- change_status 변경상태 상태 1:준비 2:진행중 3:보류 4:완료 -->
                        <div class="tag-icon ty01" v-if="comment.changeType == '1'">{{t('message.create')}}</div>
                        <div class="tag-icon ty02" v-if="comment.changeType == '2'">{{t('message.comment')}}</div>
                        <div class="tag-icon ty03" v-if="comment.changeType == '3'">
                          {{comment.changeStatus=='1'?t('message.ready'):''}}
                          {{comment.changeStatus=='2'?t('message.inProgress'):''}}
                          {{comment.changeStatus=='3'?t('message.onHold'):''}}
                          {{comment.changeStatus=='4'?t('message.complete'):''}}
                        </div>
                        <div class="tag-icon ty04" v-if="comment.changeType == '4'">{{t('message.send')}}</div>
                        <div class="tag-icon ty02" v-if="comment.changeType == '5'">{{t('message.deleteComment')}}</div>
                      </div>

                      <span class="t1">{{ comment.memberName?comment.memberName:t('message.noInfo') }} / {{ comment.deptName?comment.deptName:t('message.noInfo') }} / {{ comment.posName?comment.posName:t('message.noInfo') }}</span>
                      <div class="inner" v-if="comment.changeType == '4'">
                        <span class="ico-arr" aria-hidden="true"></span>
                        <span class="t2" v-if="comment.targetType == '3'">{{ comment.targetMemberName }} / {{ comment.targetDeptName }} / {{ comment.targetPosName }}</span>
                        <span class="t2" v-if="comment.targetType == '2'">{{ comment.targetName }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="txt-group2" v-if="comment.comment || (comment.changeStatus=='3'&&comment.changeType=='3')">
                    <div class="txt">{{comment.changeStatus=='3'&&comment.changeType=='3'?comment.logMsg:comment.comment}}</div>
                    <div class="img-group" v-if="comment.filePath">
                      <div class="item">
                        <v-btn @click="onClickPreview(comment, 'comment')">
                          <img :src="utils.getBaseUrl('comment', comment.filePath)">
                        </v-btn>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <InputComment :idx="item.idx" @confirmComment="confirmComment"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <DialogImgView v-model="previewDialogModel" @close="previewDialogModel=false" :src="previewSrc"/>
  <DialogTargetAdd4 v-model="targetDialogModel" @close="targetDialogModel=false" @confirm="confirmTarget"/>
  <DialogReason v-model="delayDialogModel" @close="delayDialogModel=false" @confirm="confirmDelay"/>
  <DialogActionComplete v-model="actionCompleteDialogModel" @close="actionCompleteDialogModel=false" @confirm="confirmActionComplete"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
  <c-dialog
    v-model="dialogActionDeleteModel"
    v-bind="dialogActionDeleteBind"
    @close="dialogActionDeleteModel=false"
    @confirm="confirmDelete"
  />
  <c-dialog
    v-model="dialogActionCompleteModel"
    v-bind="dialogActionCompleteBind"
    @close="dialogActionCompleteModel=false"
    @confirm="confirmComplete"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import TimelineService from "@/services/timeline.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()
let viewIdx = route.params.idx?route.params.idx:storeRef.viewIdx.value

//bind
const previewDialogModel = ref(false)
const targetDialogModel = ref(false)
const delayDialogModel = ref(false)
const actionCompleteDialogModel = ref(false)
const item:any = ref({})
const previewSrc = ref('')
const timelineImageModel = ref(0)
const prevStatus = ref(0)
const snackbar = ref(false)
const snackText = ref('')
const dialogActionDeleteModel = ref(false)
const dialogActionCompleteModel = ref(false)

//ui
const dialogActionDeleteBind = {
  dialogTit: t('message.delete'),
  dialogText: t('message.deleteConfirmation'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}

const dialogActionCompleteBind = {
  dialogTit: t('message.update'),
  dialogText: t('message.confirmCompleteIrreversible'),
  btn1Text: t('message.confirm'),
  btn1Show: true,
}

//hook
onMounted(() => {
  onClickSearch()
})

//function
const isTargetButtonAble=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  return ( (item.value.memberIdx == user.memberIdx)  //본인글 이거나
    || (item.value.targetMemberIdx == user.memberIdx && item.value.targetType == '3')  //본인타겟 이거나
    || (item.value.targetDeptIdx == user.deptIdx && item.value.targetType == '2') //본인부서 이거나
    || user.headYn == 'Y') //조직장 이거나
  && item.value.status != '4'  // 완료 아니고
}

const isMyBoard=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  return (item.value.memberIdx === user.memberIdx)
}

const onClickSearch=()=>{
  let params = {
    idx:viewIdx
  }

  TimelineService.getTimelineList(params).then(
    (response) => {
      //타임라인
      if(response.result.length > 0)
        item.value = response.result[0]
      item.value.typeText = item.value.type=='1'?t('message.correctiveSafetyTalk'):t('message.supportiveSafetyTalk')
      item.value.actionYnText = item.value.actionYn=='Y'?t('message.necessary'):t('message.notNecessary')
      item.value.targetText = t('message.none')
      if(item.value.targetType == '2') item.value.targetText = item.value.targetDeptName
      else if(item.value.targetType == '3') item.value.targetText = item.value.targetMemberName
      item.value.goalDate = dayjs(item.value.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '':dayjs(item.value.goalDate).format('YYYY-MM-DD')
      item.value.statusText = t('message.ready')
      if(item.value.status == '2')
        item.value.statusText = t('message.inProgress')
      else if(item.value.status == '3')
        item.value.statusText = t('message.onHold')
      else if(item.value.status == '4')
        item.value.statusText = t('message.complete')
      prevStatus.value = item.value.status
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const onClickPreview=(item, type)=>{
  previewSrc.value = utils.getBaseUrl(type, item.filePath)
  previewDialogModel.value = true
}

const onChangeStatus=()=>{
  if(prevStatus.value == item.value.status)
    return
  //딜레이팝업
  if(item.value.status == '3'){
    item.value.status = prevStatus.value
    delayDialogModel.value = true
    return
  } //완료처리 시 경고메시지
  else if(item.value.status == '4'){
    //시정조치 필요한 케이스면 추가정보 필요함
    if(item.value.actionYn == 'Y' && item.value.type == '1'){
      /*
      storeRef.timelineIdx.value = item.value.idx
      item.value.status = prevStatus.value
      actionCompleteDialogModel.value = true
       */
      item.value.status = prevStatus.value
      dialogActionCompleteModel.value = true
      return
    }
    else {  //그 외는 알람메시지 노출 후 변경
      item.value.status = prevStatus.value
      dialogActionCompleteModel.value = true
      return
    }
  }
  else {  //그외는 바로 변경
    item.value.targetType = null
    item.value.targetDeptIdx = 0
    item.value.targetMemberIdx = 0
    item.value.changeType = '3'
    changeStatus('')
  }
}

const changeStatus=(delayReason)=>{
  let params = {
    idx:viewIdx,
    status:item.value.status,
    changeType:item.value.changeType,
    delayReason:delayReason,
    targetType:item.value.targetType,
    targetMemberIdx:item.value.targetMemberIdx,
    targetDeptIdx:item.value.targetDeptIdx,
    actionYn:item.value.actionYn
  }

  TimelineService.updateTimeline(params).then(
    (response) => {
      prevStatus.value = item.value.status
      delayDialogModel.value=false
      onClickSearch()
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const confirmComment=(params)=>{
  //item.value.timelineComments.unshift(params)
  onClickSearch()
}

const onClickDeleteComment=(comment)=>{
  let params = {
    idx:comment.idx
  }

  TimelineService.deleteTimelineComment(params).then(
    (response) => {
      item.value.timelineComments = _.pull(item.value.timelineComments, comment)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

//딜레이팝업 컨펌
const confirmDelay=(params)=>{
  item.value.status = '3' //딜레이
  item.value.changeType = '3' //상태변경
  item.value.targetType = null
  item.value.targetDeptIdx = 0
  item.value.targetMemberIdx = 0
  changeStatus(params)
}

//완료변경
const confirmComplete=(params)=>{
  item.value.status = '4' //완료
  item.value.changeType = '3'  //상태변경
  item.value.targetType = null
  item.value.targetDeptIdx = 0
  item.value.targetMemberIdx = 0
  changeStatus(params)
}

//시정조치완료 컨펌 -> 완료처리
const confirmActionComplete=(params)=>{
  item.value.status = '4' //완료
  item.value.changeType = '3'  //상태변경
  item.value.targetType = null
  item.value.targetDeptIdx = 0
  item.value.targetMemberIdx = 0
  changeStatus(params)
}

const onClickTarget=()=>{
  if(item.value.status == '4')
    return

  const user = JSON.parse(localStorage.getItem('user'))
  if(item.value.memberIdx==user.memberIdx || item.value.targetMemberIdx==user.memberIdx || 'Y' == user.headYn) {
    storeRef.popupType.value = item.value.targetType
    //2부서 3개인
    storeRef.popupIdx.value = item.value.targetType == '3' ? item.value.targetMemberIdx : item.value.targetDeptIdx
    targetDialogModel.value = true
  }
}

const confirmTarget=(params)=>{
  if(params.length <= 0){
    snackText.value = '선택 항목이 없습니다'
    snackbar.value = true
  }
  else {
    item.value.status = '1' //시정조치상태 1:준비 2:진행중 3:보류 4:완료
    item.value.changeType = '4' //로그에 저장 할 상태 1:생성 2:코멘트 3:상태변경 4:전달 5:코멘트삭제
    item.value.targetType = params[0].targetType //대상자 1:없음 2:부서 3:구성원
    item.value.actionYn = 'Y'
    if(params[0].targetType == '2')
      item.value.targetDeptIdx = params[0].idx
    else
      item.value.targetMemberIdx = params[0].idx
    changeStatus('')
  }
}

const confirmDelete=()=>{
  let params = {
    idx:viewIdx
  }

  TimelineService.deleteTimeline(params).then(
    (response) => {
      snackText.value = 'success'
      snackbar.value = true
      setTimeout(() => utils.movePage('/myBoard'), 2000);
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
</script>



<style lang="scss" scoped>
</style>
